export const depositAccountsParser = accounts => {
  return accounts?.length
    ? accounts?.map(account => {
        return {
          id: account?.id,
          type: account?.vpa ? 'upi' : 'bank',
          bankName: account?.bank_name,
          holderName: account?.account_holder_name,
          ifsc: account?.ifsc,
          accountNumber: account?.account_number,
          vpa: account?.vpa,
          verified: account?.is_verified,
        }
      })
    : []
}
